<template>
  <div class="content">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">{{ getModelName }}</h3>
            <p class="text-sm mb-0">
              Update link
            </p>
          </template>
          <div v-if="links" >
            <b-card no-body v-if="!hasCurrentLink">
              <b-card-body>
                <form>
                  <b-container fluid="xl">
                    <b-row align-v="center" class="form-group">
                      <b-col cols="2">
                        <div>
                          <base-input type="date" v-model="formFromDate" :required=true />
                        </div>
                        <div>
                          <base-input type="time" v-model="formFromTime" :required=true />
                        </div>
                      </b-col>
                      <b-col cols="3">
                      </b-col>
                      <b-col cols="2" align="center" >
                        <el-select width="120"
                                   filterable
                                   placeholder="Assets"
                                   v-model="formAsset"
                                   :required=true
                                   v-if="loadAssets">
                          <el-option v-for="asset in assets"
                                     :key="asset.name"
                                     :label="asset.name"
                                     :value="asset.id">
                          </el-option>
                        </el-select>
                        <p/>
                        <div>
                          <base-button size="sm" type="neutral" @click.native="handleAddLink()">Add link</base-button>
                        </div>
                      </b-col>
                      <b-col cols="5">
                      </b-col>
                    </b-row>
                  </b-container>
                </form>
              </b-card-body>
            </b-card>
            <b-card no-body v-for="link in links">
              <b-card-body>
                <b-container fluid="xl">
                  <b-row align-v="center">
                    <b-col cols="4">
                      <div>
                        {{ $formatDate(new Date(link.from)) }}
                      </div>
                      <div>
                        <h3>{{ $formatTime(new Date(link.from)) }}</h3>
                      </div>
                    </b-col>
                    <b-col cols="4" align="center">
                      {{ link.assetName }}
                      <p/>
                      <div v-if="!link.until">
                        <base-button size="sm" type="neutral" @click.native="handleEndLink()">End link</base-button>
                      </div>
                      <div v-if="link.until">
                        <base-button size="sm" type="neutral" @click.native="handleDeleteLink(link.id)">Delete link</base-button>
                      </div>
                    </b-col>
                    <b-col cols="4" align="right" v-if="link.until">
                      <div>
                        {{ $formatDate(new Date(link.until)) }}
                      </div>
                      <div>
                        <h3>{{ $formatTime(new Date(link.until)) }}</h3>
                      </div>
                    </b-col>
                    <b-col cols="2" v-if="!link.until">
                    </b-col>
                    <b-col cols="2" align="right" v-if="!link.until">
                        <div>
                          <base-input type="date" v-model="formUntilDate" :required=true />
                        </div>
                        <div>
                          <base-input type="time" v-model="formUntilTime" :required=true />
                        </div>
                      </b-col>
                  </b-row>
                </b-container>
              </b-card-body>
            </b-card>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import crudApi from "../../crud/crud-api";
import {Option, Select} from "element-ui";
import {formatTime} from "../../util/formatting";

export default {
  name: "CrudLink",
  props: ['model', 'entityType'],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data: _ => ({
    formFromDate: undefined,
    formFromTime: undefined,
    formUntilDate: undefined,
    formUntilTime: undefined,
    formAsset: undefined,
    links: undefined,
    assets: undefined
  }),
  created() {
    this.loadLinks()

    this.updateTimes()
  },
  computed: {
    loadAssets() {
      crudApi.getAll('assets', this.$store.state.auth.user.organisation_id).then(json => this.assets = json.data ? json.data : json);

      return true
    },
    hasCurrentLink() {
      if (this.links !== undefined && this.links.length > 0) {
        return this.links[0].until === undefined
      } else {
        return false
      }
    },
    getModelName() {
      if (this.entityType === 'devices') {
        return this.model.name
      } else if (this.entityType === 'drivers') {
        return this.model.firstName + ' ' + this.model.lastName
      }
    }
  },
  watch: {
    links: function (val) {
      this.updateTimes()
    }
  },
  methods: {
    handleAddLink() {
      console.log("Adding link : " + this.formFromDate + "T" + this.formFromTime + " => " + this.formAsset)

      if (this.entityType === 'devices') {
        crudApi.createAssetDeviceLink(this.formAsset, this.model.id, new Date(Date.parse(this.formFromDate + "T" + this.formFromTime))).then(() => this.loadLinks())
      } else if (this.entityType === 'drivers') {
        crudApi.createAssetDriverLink(this.formAsset, this.model.id, new Date(Date.parse(this.formFromDate + "T" + this.formFromTime))).then(() => this.loadLinks())
      }
    },
    handleEndLink() {
      console.log("Ending link : " + this.formUntilDate + "T" + this.formUntilTime + " => " + this.links[0].assetId)

      if (this.entityType === 'devices') {
        crudApi.terminateAssetDeviceLink(this.links[0].assetId, this.model.id, new Date(Date.parse(this.formUntilDate + "T" + this.formUntilTime))).then(() => this.loadLinks())
      } else if (this.entityType === 'drivers') {
        crudApi.terminateAssetDriverLink(this.links[0].assetId, this.model.id, new Date(Date.parse(this.formUntilDate + "T" + this.formUntilTime))).then(() => this.loadLinks())
      }
    },
    handleDeleteLink(id) {
      console.log("Deleting link : " + id)

      if (this.entityType === 'devices') {
        crudApi.deleteDeviceLink(id).then(() => this.loadLinks())
      } else if (this.entityType === 'drivers') {
        crudApi.deleteDriverLink(id).then(() => this.loadLinks())
      }
    },
    loadLinks() {
      if (this.entityType === 'devices') {
        console.log("Loading device links")

        crudApi.getDeviceLinks(this.model.id, new Date('2021-07-01T00:01:00.000Z')).then(json => this.links = json.data ? json.data.reverse() : json);
      } else if (this.entityType === 'drivers') {
        console.log("Loading driver links")

        crudApi.getDriverLinks(this.model.id, new Date('2021-07-01T00:01:00.000Z')).then(json => this.links = json.data ? json.data.reverse() : json);
      }
    },
    updateTimes() {
      let time = new Date(this.getLastLinkTime())
      time.setSeconds(time.getSeconds() + 1);

      this.formFromDate = time.toISOString().slice(0,10)
      this.formFromTime = formatTime(time)

      let now = new Date()
      if (now < time) {
        this.formUntilDate = time.toISOString().slice(0,10)
        this.formUntilTime = formatTime(time)
      } else {
        this.formUntilDate = now.toISOString().slice(0,10)
        this.formUntilTime = formatTime(now)
      }
    },
    getLastLinkTime() {
      if (this.links !== undefined && this.links.length > 0) {
        if (this.links[0].until !== undefined) {
          return this.links[0].until
        } else {
          return this.links[0].from
        }
      } else {
        return new Date()
      }
    }
  }
};
</script>

<style scoped>

</style>
